module.exports = __webpack_public_path__ + "img/init_account.f30b958.png";